<template>
  <div>
    <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">{{ title }}</h4>
            <div class="d-flex justify-content-end mb-2" style="gap: 8px">
              <button type="button" class="btn btn-primary btn-rounded" @click="showFilters()">
                <i class="mdi mdi-filter mr-1"></i> Filtros
              </button>
              <button type="button" class="btn btn-success btn-rounded" @click="exportParticipants()">
                <i class="mdi mdi-file-export-outline mr-1"></i> Exportar Dados
              </button>
            </div>
            <div class="table-responsive">
              <table class="table table-centered table-hover w-100">
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Grupo</th>
                    <th>UF</th>
                    <th style="white-space:nowrap">Inscrição</th>
                    <th style="white-space:nowrap">Atualização</th>
                    <th style="white-space:nowrap">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="list in participants" :key="list.id" :class="{'inativado': parseInt(list.status) === 5}">
                    <td>
                      <h5 class="font-size-14 mb-1" style="white-space: nowrap;text-overflow: ellipsis;max-width: 275px;overflow: hidden;">{{ list.name }}</h5>
                      <p class="text-muted mb-0">{{ list.email }}</p>
                    </td>
                    <td>
                      <GroupBadges :participant="list" />
                    </td>
                    <td style="font-size: 12px !important">{{ list.state }}</td>
                    <td style="font-size: 12px !important">{{ list.inscricao }}</td>
                    <td style="font-size: 12px !important">{{ list.atualizacao }}</td>
                    <td>
                      <span
                        :class="statusClass[list.status]"
                        class="badge font-size-12 p-2" style="min-width: 120px">
                          {{ statusList[list.status] }}
                      </span><br />
                      <span
                        v-if="list.ref_status"
                        class="badge font-size-11 p-1 badge-secondary" style="min-width: 120px;margin-top:2px">
                          {{ refstatusList[list.ref_status] }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
    <modal-filter ref="modalFilter" @participantFiltered="getReport"></modal-filter>
    <export-modal ref="exportModal" title="Exportar Aéreos" />
  </div>
</template>
<script>
// Import component
import appConfig from '@/app.config'
import serviceReport from '../services'
import modalFilter from '@/components/modals/filters/ParticipantFilter'
import ExportModal from '@/components/modals/ExportModal'
import GroupBadges from '@/components/GroupBadges'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    GroupBadges,
    modalFilter,
    ExportModal
  },
  name: 'report-participants',
  page: {
    title: 'Relatório de Participantes com aéreos',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      avatar: require('@/assets/images/users/user-default.png'),
      params: {},
      totalRows: 1,
      rows: 0,
      currentPage: 1,
      participants: [],
      statusClass: ['badge-dark', 'badge-primary', 'badge-warning', 'badge-success', 'badge-danger', 'badge-secondary'],
      perPage: 20,
      title: 'Relatório de Participantes com aéreos',
      items: [{
        text: 'Relatórios'
      },
      {
        text: 'Participantes - Aéreos',
        active: true
      }
      ]
    }
  },
  mounted () {
    let loeader = this.$loading.show()
    serviceReport.listParticipants({ limit: this.perPage, include: 'group' }).then((res) => {
      this.participants = res.data
      this.rows = res.meta.pagination.total
      this.currentPage = res.meta.pagination.current_page
      loeader.hide()
    }).catch(error => {
      console.log(error)
      loeader.hide()
    })
    this.totalRows = this.rows
    this.GetStatus()
    this.GetRefStatus()
  },
  created () {},
  computed: {
    ...mapState('settings', ['statusList', 'refstatusList'])
  },
  methods: {
    ...mapActions('settings', { GetStatus: 'GetStatusList' }),
    ...mapActions('settings', { GetRefStatus: 'GetRefStatusList' }),
    showFilters () {
      this.$refs.modalFilter.open()
    },
    exportParticipants () {
      this.$refs.exportModal.start(() => serviceReport.exportParticipantsAir(this.params))
    },
    getReport (filter = '') {
      let loeader = this.$loading.show()
      let params = {
        group_id: filter.group_id || null,
        noCompanion: 1,
        limit: this.perPage,
        page: this.currentPage,
        status: filter.status || null,
        ref_status: filter.ref_status || null,
        city: filter.city || null,
        district: filter.district || null,
        isOnline: filter.isOnline || null,
        need_payment: filter.need_payment || null,
        payment_completed: filter.payment_completed || null,
        created_start: filter.created_start ? this.$moment(filter.created_start).format('YYYY-MM-DD') : null,
        created_end: filter.created_end ? this.$moment(filter.created_end).format('YYYY-MM-DD') : null,
        confirmation_date_start: filter.confirmation_date_start ? this.$moment(filter.confirmation_date_start).format('YYYY-MM-DD') : null,
        confirmation_date_end: filter.confirmation_date_end ? this.$moment(filter.confirmation_date_end).format('YYYY-MM-DD') : null,
        aereo: filter.aereo || null,
        companion: filter.companion || null,
        csm: filter.csm || null,
        school: filter.school || null,
        food_restriction: filter.food_restriction || null
      }
      params.tags = filter.tagsIds || null
      this.params = params
      console.log(params)
      serviceReport.listParticipants(params).then((res) => {
        this.participants = res.data
        if (res.data.length > 0) {
          this.rows = res.meta.pagination.total
          this.currentPage = res.meta.pagination.current_page
        }
        loeader.hide()
      }).catch(error => {
        console.log(error)
        loeader.hide()
      })
    },
    updateList () {
      this.getReport(this.params)
    }
  },
  watch: {
    currentPage () { this.updateList() },
    total () { this.updateList() },
    dataPerPage () { this.updateList() }
  }
}
</script>
<style scoped>
.inativado { background: #f7ebeb }
.link { cursor: pointer; }
.swal2-popup {
  font-size: 11px !important;
}
.table-responsive { min-height: 300px;}
</style>
